import { Select, SelectProps } from '@shared/Form/Select'
import { useChargeStatusEnum } from '@services/device/chargingpoint'
import { useTranslation } from 'react-i18next'

type Props = {
  showAll?: boolean
} & SelectProps

export const ChargeStatusSelect = (props: Props) => {
  const { showAll = false, ...otherProps } = props
  const { t } = useTranslation()
  const { data } = useChargeStatusEnum()

  return (
    <Select className="w-full" allowClear {...otherProps}>
      {showAll && (
        <Select.Option key="all" value="">
          {t('common:all')}
        </Select.Option>
      )}
      {data.map(x => (
        <Select.Option key={x.id} value={x.id}>
          <div className="flex items-center">
            <span>{x?.label}</span>
          </div>
        </Select.Option>
      ))}
    </Select>
  )
}

export default ChargeStatusSelect
